import React, { type ReactElement } from 'react';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import IconActionLink from 'atom-components/table-outdated/icon-action-link';
import AreaUserPolicy from 'policies/area-user.policy';
import { useAreaAccess } from 'services/providers/area-access.provider';
import { convertAreaToTheme } from 'services/providers/theme.provider';
import type { DashboardArea } from './types';

type Props = {
  area: DashboardArea;
};

export default function AreaCard({ area }: Props): ReactElement {
  const { authorisableUser, userMinusSiteAdmin, authorisableArea, isLoading } = useAreaAccess();

  return (
    <div
      data-theme={convertAreaToTheme(area.identifier)}
      className={clsx('card area-card', {
        historic: area.isHistoric,
        active: area.isActive
      })}
      key={`card-${area.id}`}
    >
      <Link
        to={`/product/${area.product.id}/area/${area.id}/test-instances`}
        className="text-body h-100"
      >
        <span className="historic-label">Historic</span>
        <h5 className="card-title m-auto p-1">
          {area.alternativeName && (
            <>
              {area.alternativeName}
              <br className="mb-3" />
              {area.name}
            </>
          )}
          {!area.alternativeName && area.name}
        </h5>
      </Link>
      {area.isActive && (
        <div className="badge-wrapper">
          {!isLoading && AreaUserPolicy.list(authorisableUser, authorisableArea) && (
            <IconActionLink
              id={`manage-${area.id}`}
              to={`/manage-area?areaId=${area.id}&organisationAreaId=${area.customerArea?.id}`}
              icon="user-gear"
              size="1x"
              buttonClassName="p-1"
              tooltip="Manage Area"
              className={clsx({
                'site-admin-text': !AreaUserPolicy.list(userMinusSiteAdmin, authorisableArea)
              })}
            />
          )}
        </div>
      )}
    </div>
  );
}
